// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/demand_confirm_record_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { ConfirmationDetailState, ConfirmationLeafKind, ConfirmationSlotOrigin, ConfirmCategory, DemandConfirmRecordSummary, PlanningSection } from "./demand_confirm_record_model_pb";
import { file_bffuser_v1_demand_confirm_record_model } from "./demand_confirm_record_model_pb";
import type { DemandForecastProvider, SlotValue } from "./demand_forecast_service_pb";
import { file_bffuser_v1_demand_forecast_service } from "./demand_forecast_service_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/demand_confirm_record_service.proto.
 */
export const file_bffuser_v1_demand_confirm_record_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_bffuser_v1_demand_confirm_record_model, file_bffuser_v1_demand_forecast_service, file_buf_validate_validate, file_google_protobuf_timestamp]);

/**
 * ListDemandConfirmRecordsRequest carries no organization_id; the BFF
 * handler resolves the organization from the eauth session.
 *
 * @generated from message bffuser.v1.ListDemandConfirmRecordsRequest
 */
export type ListDemandConfirmRecordsRequest = Message<"bffuser.v1.ListDemandConfirmRecordsRequest"> & {
  /**
   * planning_section_filter narrows results to a specific planning
   * section. UNSPECIFIED (= 0) means no filter (all sections).
   *
   * @generated from field: bffuser.v1.PlanningSection planning_section_filter = 3;
   */
  planningSectionFilter: PlanningSection;

  /**
   * area_code_filter narrows results to a specific area.
   * UNSPECIFIED (= 0) means no filter (all areas).
   *
   * @generated from field: optional bfftypes.v1.AreaCode area_code_filter = 4;
   */
  areaCodeFilter?: AreaCode;

  /**
   * confirm_category_filter narrows results to a specific category.
   * UNSPECIFIED (= 0) means no filter (all categories).
   *
   * @generated from field: bffuser.v1.ConfirmCategory confirm_category_filter = 5;
   */
  confirmCategoryFilter: ConfirmCategory;

  /**
   * bg_code narrows results to a specific submission-responsible BG (OCCTO
   * 5-char code). Unset means no filter. frontend resolves this from
   * useGetWorkflowCase(caseId).bgCode (demand-confirm-record-bg-axis Design
   * Note Decision #4).
   *
   * @generated from field: optional string bg_code = 7;
   */
  bgCode?: string;
};

/**
 * Describes the message bffuser.v1.ListDemandConfirmRecordsRequest.
 * Use `create(ListDemandConfirmRecordsRequestSchema)` to create a new message.
 */
export const ListDemandConfirmRecordsRequestSchema: GenMessage<ListDemandConfirmRecordsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_confirm_record_service, 0);

/**
 * @generated from message bffuser.v1.ListDemandConfirmRecordsResponse
 */
export type ListDemandConfirmRecordsResponse = Message<"bffuser.v1.ListDemandConfirmRecordsResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.DemandConfirmRecordSummary records = 1;
   */
  records: DemandConfirmRecordSummary[];
};

/**
 * Describes the message bffuser.v1.ListDemandConfirmRecordsResponse.
 * Use `create(ListDemandConfirmRecordsResponseSchema)` to create a new message.
 */
export const ListDemandConfirmRecordsResponseSchema: GenMessage<ListDemandConfirmRecordsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_confirm_record_service, 1);

/**
 * @generated from message bffuser.v1.GetConfirmationBundleRequest
 */
export type GetConfirmationBundleRequest = Message<"bffuser.v1.GetConfirmationBundleRequest"> & {
  /**
   * @generated from field: string bg_confirm_record_id = 2;
   */
  bgConfirmRecordId: string;
};

/**
 * Describes the message bffuser.v1.GetConfirmationBundleRequest.
 * Use `create(GetConfirmationBundleRequestSchema)` to create a new message.
 */
export const GetConfirmationBundleRequestSchema: GenMessage<GetConfirmationBundleRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_confirm_record_service, 2);

/**
 * @generated from message bffuser.v1.GetConfirmationBundleResponse
 */
export type GetConfirmationBundleResponse = Message<"bffuser.v1.GetConfirmationBundleResponse"> & {
  /**
   * @generated from field: bool legacy = 1;
   */
  legacy: boolean;

  /**
   * @generated from field: string bg_confirm_record_id = 2;
   */
  bgConfirmRecordId: string;

  /**
   * @generated from field: repeated bffuser.v1.ConfirmationRetailerSummary retailers = 3;
   */
  retailers: ConfirmationRetailerSummary[];
};

/**
 * Describes the message bffuser.v1.GetConfirmationBundleResponse.
 * Use `create(GetConfirmationBundleResponseSchema)` to create a new message.
 */
export const GetConfirmationBundleResponseSchema: GenMessage<GetConfirmationBundleResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_confirm_record_service, 3);

/**
 * @generated from message bffuser.v1.ConfirmationRetailerSummary
 */
export type ConfirmationRetailerSummary = Message<"bffuser.v1.ConfirmationRetailerSummary"> & {
  /**
   * @generated from field: string retailer_code = 1;
   */
  retailerCode: string;

  /**
   * @generated from field: string retailer_label = 2;
   */
  retailerLabel: string;

  /**
   * @generated from field: string retail_confirm_record_id = 3;
   */
  retailConfirmRecordId: string;

  /**
   * @generated from field: bool grouped = 4;
   */
  grouped: boolean;

  /**
   * @generated from field: repeated bffuser.v1.ConfirmationDetailState leaf_detail_states = 5;
   */
  leafDetailStates: ConfirmationDetailState[];

  /**
   * @generated from field: optional string prior_retail_confirm_record_id = 6;
   */
  priorRetailConfirmRecordId?: string;

  /**
   * @generated from field: repeated bffuser.v1.SlotValue forecast_slots = 7;
   */
  forecastSlots: SlotValue[];
};

/**
 * Describes the message bffuser.v1.ConfirmationRetailerSummary.
 * Use `create(ConfirmationRetailerSummarySchema)` to create a new message.
 */
export const ConfirmationRetailerSummarySchema: GenMessage<ConfirmationRetailerSummary> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_confirm_record_service, 4);

/**
 * @generated from message bffuser.v1.ListConfirmationLeavesRequest
 */
export type ListConfirmationLeavesRequest = Message<"bffuser.v1.ListConfirmationLeavesRequest"> & {
  /**
   * @generated from field: string bg_confirm_record_id = 2;
   */
  bgConfirmRecordId: string;

  /**
   * @generated from field: optional string retailer_code = 3;
   */
  retailerCode?: string;

  /**
   * @generated from field: int32 page_size = 4;
   */
  pageSize: number;

  /**
   * @generated from field: string cursor = 5;
   */
  cursor: string;
};

/**
 * Describes the message bffuser.v1.ListConfirmationLeavesRequest.
 * Use `create(ListConfirmationLeavesRequestSchema)` to create a new message.
 */
export const ListConfirmationLeavesRequestSchema: GenMessage<ListConfirmationLeavesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_confirm_record_service, 5);

/**
 * @generated from message bffuser.v1.ListConfirmationLeavesResponse
 */
export type ListConfirmationLeavesResponse = Message<"bffuser.v1.ListConfirmationLeavesResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.ConfirmationLeafSnapshot leaves = 1;
   */
  leaves: ConfirmationLeafSnapshot[];

  /**
   * @generated from field: string next_cursor = 2;
   */
  nextCursor: string;
};

/**
 * Describes the message bffuser.v1.ListConfirmationLeavesResponse.
 * Use `create(ListConfirmationLeavesResponseSchema)` to create a new message.
 */
export const ListConfirmationLeavesResponseSchema: GenMessage<ListConfirmationLeavesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_confirm_record_service, 6);

/**
 * @generated from message bffuser.v1.ConfirmationLeafSnapshot
 */
export type ConfirmationLeafSnapshot = Message<"bffuser.v1.ConfirmationLeafSnapshot"> & {
  /**
   * @generated from field: string retailer_code = 1;
   */
  retailerCode: string;

  /**
   * @generated from field: bffuser.v1.ConfirmationLeafKind leaf_kind = 2;
   */
  leafKind: ConfirmationLeafKind;

  /**
   * @generated from field: string leaf_key = 3;
   */
  leafKey: string;

  /**
   * @generated from field: string label = 4;
   */
  label: string;

  /**
   * @generated from field: google.protobuf.Timestamp source_draft_updated_at = 5;
   */
  sourceDraftUpdatedAt?: Timestamp;

  /**
   * @generated from field: repeated bffuser.v1.SlotValue forecast_slots = 6;
   */
  forecastSlots: SlotValue[];

  /**
   * @generated from field: repeated bffuser.v1.ConfirmationSlotOrigin slot_origins = 7;
   */
  slotOrigins: ConfirmationSlotOrigin[];

  /**
   * @generated from field: repeated bffuser.v1.SlotValue provider_slots = 8;
   */
  providerSlots: SlotValue[];

  /**
   * @generated from field: bffuser.v1.DemandForecastProvider provider = 9;
   */
  provider: DemandForecastProvider;

  /**
   * @generated from field: optional string provider_other = 10;
   */
  providerOther?: string;

  /**
   * @generated from field: optional string provider_label = 11;
   */
  providerLabel?: string;

  /**
   * @generated from field: repeated int32 manual_edit_komas = 12;
   */
  manualEditKomas: number[];
};

/**
 * Describes the message bffuser.v1.ConfirmationLeafSnapshot.
 * Use `create(ConfirmationLeafSnapshotSchema)` to create a new message.
 */
export const ConfirmationLeafSnapshotSchema: GenMessage<ConfirmationLeafSnapshot> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_confirm_record_service, 7);

/**
 * DemandConfirmRecordService provides Connect RPCs for reading demand
 * confirm record history (確定履歴). All RPCs are read-only.
 *
 * @generated from service bffuser.v1.DemandConfirmRecordService
 */
export const DemandConfirmRecordService: GenService<{
  /**
   * ListDemandConfirmRecords returns the list of demand confirm records
   * that match the supplied filters, sorted by confirmed_at descending.
   *
   * @generated from rpc bffuser.v1.DemandConfirmRecordService.ListDemandConfirmRecords
   */
  listDemandConfirmRecords: {
    methodKind: "unary";
    input: typeof ListDemandConfirmRecordsRequestSchema;
    output: typeof ListDemandConfirmRecordsResponseSchema;
  },
  /**
   * @generated from rpc bffuser.v1.DemandConfirmRecordService.GetConfirmationBundle
   */
  getConfirmationBundle: {
    methodKind: "unary";
    input: typeof GetConfirmationBundleRequestSchema;
    output: typeof GetConfirmationBundleResponseSchema;
  },
  /**
   * @generated from rpc bffuser.v1.DemandConfirmRecordService.ListConfirmationLeaves
   */
  listConfirmationLeaves: {
    methodKind: "unary";
    input: typeof ListConfirmationLeavesRequestSchema;
    output: typeof ListConfirmationLeavesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_demand_confirm_record_service, 0);

